import axios from "axios";
import { useDispatch } from "react-redux";
import { setNomePrenotazione, setCurrentBalance, setCurrentBalanceEnrica, setCurrentPod, setInfo, setLoggedIn, setPodsList, setOfferta, setExpiryBalanceEnrica, setDatiPagamento, setNuoviDatiContratto, setNotifiche, setTotaleConsumi, setTotaleOneri, setUltimoSaldo, setTotaleSaldo, setIdGruppo, setPayMethodDefaulttiPagamento, setRinnovoContrattuale } from '../features/userSlice'
import { setOverlayNotice, setRicarica3612Effettuata, setSwitchGraphMonth, setSwitchGraphWeek, setSwitchGraphYear, setSwitchMonth, setSwitchViewWeek, setSwitchViewYear, setSwitchWeek, setView } from "../features/settingSlice";
import { setDataMin } from "../features/dataMonthSlice";
import { DateTime, Settings } from "luxon";
import { setDataBox } from "../features/dataBoxHomeSlice";
import { setPopupBody } from "../features/popupSlice";


export function useFetchLogin() {
    const dispatch = useDispatch()
    const username = localStorage.getItem('username')
    const password = localStorage.getItem('password')
    const loginApi = `https://my.revoluce.it/area_utente/gestione/api/login/login.php?username=${username}&password=${password}`;
    return () => {
        axios.get(loginApi).then(({ data }) => {
            dispatch(setPopupBody({body_popup: data.body_popup, titolo_popup: data.titolo_popup, btn_popup: data.btn_popup, link_popup: data.link_popup}))
            dispatch(setRinnovoContrattuale(data.body_nuovo_contratto))
            dispatch(setOverlayNotice(data.flag_popup))
            dispatch(setRicarica3612Effettuata(data.exist_prenotazione))
            dispatch(setNomePrenotazione(data.nome_prenotazione))
            dispatch(setDatiPagamento(data.dati_pagamento))
            dispatch(setOfferta(data.nome_offerta))
            let notifiche = []
            notifiche = [data.notificheRid, data.notificheToken]
            dispatch(setNotifiche(notifiche))
            dispatch(setIdGruppo(data.id_gruppo))
            dispatch(setTotaleConsumi(data.label_consumi))
            dispatch(setTotaleOneri(data.label_altri_oneri))
            dispatch(setUltimoSaldo(data.label_credito_iniziale))
            dispatch(setTotaleSaldo(data.label_totale_saldo))
            const config = data.config_app;
            dispatch(setDataMin(data.data_min));
            dispatch(setView(config.set_view))
            dispatch(setSwitchWeek(config.graph_week))
            dispatch(setSwitchMonth(config.graph_month))
            dispatch(setSwitchGraphYear(config.set_graph_year))
            dispatch(setSwitchGraphMonth(config.set_graph_month))
            dispatch(setSwitchGraphWeek(config.set_graph_week))
            dispatch(setSwitchViewYear(config.set_view_year))
            dispatch(setSwitchViewWeek(config.set_view_week))
            dispatch(setSwitchMonth(config.set_view_month))
            const result = data.data[0];
            dispatch(setInfo(result))
            dispatch(setNuoviDatiContratto(data.nuovi_dati_contratto))
            dispatch(setLoggedIn())
            dispatch(setCurrentBalance(data.saldo))
            dispatch(setCurrentBalanceEnrica(data.saldo_enrica))
            dispatch(setExpiryBalanceEnrica(data.saldo_in_scadenza))
            dispatch(setCurrentPod({ podCode: result.pod_code, podName: result.nome, podAddress: result.pod_address2, podCity: result.pod_city }))
            const podsApi = `https://my.revoluce.it/area_utente/gestione/api/customers_pods/getCustomerPods2.php?codice_fiscale=${result.customer_tax_code}`
            axios.get(podsApi).then(({ data }) => {
                const podsList = data.data.map((r) => ({podStart: r.pod_start, podStartDate: r.pod_start_date, customerCode: r.customer_code, ownerCity: r.city_name,  ownerAddress: r.pod_address, taxCode: r.customer_tax_code,taxCodeGas: r.customer_tax_code_gas, podOwnerGas: r.customer_full_heading_gas, podOwner: r.customer_full_heading, revoCode: r.codice_revoluzionario, podCode: r.pod_code, podName: r.nome, podAddress: r.pod_address, username: r.user_username, password: r.user_password, customerId: r.customer_id }))
                dispatch(setPodsList(podsList))
                const slicePod = podsList.slice(-1)
                const currentPod = slicePod[0]
                // dispatch(setCurrentPod({ podCode: currentPod.podCode, podName: currentPod.podName, podAddress: currentPod.podAddress }))
            })
            const podCode = result.pod_code
            const token = result.token_value
            const userToken = result.user_id
            const dateStart = DateTime.local().startOf("month").toISODate();
            const dateEnd = DateTime.local().endOf("month").toISODate();
            const deliveryMonthNew = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;
            axios.get(deliveryMonthNew).then(({ data }) => {
                dispatch(setDataBox(data.data.consumptions))
            })
        })
    }
}

